const formatINR = (amount, showSymbol = true) => {
  return new Intl.NumberFormat("en-IN", {
    ...(showSymbol && { style: "currency" }),
    currency: "INR",
    minimumFractionDigits: 2,
  }).format(amount);
};

export { formatINR };
